import { Overlay } from 'trading-vue-js';

export default {
    name: 'EMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad',
                version: '1.0.0',
                desc: 'Exponential Moving Average',
                preset: {
                    name: `EMA $length`,
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#f7890c',
                    },
                },
            };
        },
        use_for() {
            return ['EMA'];
        },
        legend(values) {
            return [
                {
                    value: `${this.settings.applyto}`, // custom formatter
                },
                {
                    value: Number.parseFloat(values[1]).toFixed(2),
                    color: this.settings.color,
                },
            ];
        },
        calc() {
            return {
                props: {
                    length: { def: 50, text: 'Length' },
                    applyto: { def: `close`, text: 'Apply to' },
                },
                conf: { renderer: 'Spline' },
                update: `
                    let time_series;
                    if(applyto === 'open'){
                        time_series = ts(open[0])
                    }else if(applyto === 'high'){
                        time_series = ts(high[0])                        
                    }else if(applyto === 'low'){
                        time_series = ts(low[0])
                    }else if(applyto === 'hl2'){
                        time_series = ts((high[0] + low[0]) / 2)
                    }else{
                        time_series = ts(close[0])
                    }
                    return ema(time_series, length)[0]
                `,
            };
        },
    },
};
